import { render, staticRenderFns } from "./GrupoQuimico.vue?vue&type=template&id=baa2b9cc&"
import script from "./GrupoQuimico.vue?vue&type=script&lang=js&"
export * from "./GrupoQuimico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports